// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../Core.Generator/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".skiptocontent:focus{left:0;outline-color:transparent;position:absolute;top:0;transition:top .1s ease-in}.skiptocontent{background:#bf1722;border-bottom:1px solid #fff;border-bottom-right-radius:8px;border-right:1px solid #fff;color:#fff!important;left:0;padding:6px;position:absolute;top:-40px;transition:top 1s ease-out;z-index:100}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
